import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

import { enum as permissions } from '../../../../../enums/admin-permissions';

const tabs = [
	{
		href: '/marketing-funnel/main',
		name: 'Cohort analysis',
		permission: null
	},
	{
		href: '/marketing-funnel/old',
		name: 'Last version',
		isHidden: process.env.CPA_ENV === 'rocket',
		permission: null
	},
	{
		href: '/marketing-funnel/activity',
		name: 'Activity',
		permission: null
	},
	{
		href: '/marketing-funnel/affiliate-stat',
		name: 'Affiliate stat',
		permission: null
	}
].filter(item => !item.isHidden);

export default Main => withPageContainer(withIntl(Main), {
	name: 'Marketing funnel',
	tabs,
	permission: permissions.marketingFunnel
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-funnel/wrap-main.js